import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LocaleKey } from 'utils';
import {
  Image,
} from 'components';
import { WhiteContainer } from 'containers';
import { Documents } from '../instruments';

import styles from '../styles.module.scss';

interface IDocumentContainer {
  langBanner: string;
}

export const DocumentContainer:FC<IDocumentContainer> = ({ langBanner }) => {
  const { t } = useTranslation('tools');
  const language = langBanner || localStorage.getItem('lng') || LocaleKey.en;
  const baseFileUrl = 'https://storage.googleapis.com/eclipse-cdn/files/';

  return (
    <div className={styles.instruments_content}>
      {Documents.map(({
        icon,
        title,
        videoFile,
        video,
      }) => (
        <WhiteContainer
          className={styles.instruments_item}
        >
          <a
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
            href={video[langBanner || language]}
            target="_blank"
            rel="noreferrer"
          >
            <Image
              url={icon}
              className={styles.instruments_img}
            />
          </a>
          <div className={styles.instruments_title}>
            {t(title, { lng: language })}
            {' '}
          </div>
          <div className={styles.instruments_btn_container}>
            <a
              href={`${baseFileUrl}${videoFile}${langBanner || language}.pdf`}
              download
              target="_blank"
              rel="noreferrer"
              className={styles.instruments_btn}
            >
              {t('Instruments_saved_', { lng: language })}
            </a>
          </div>
        </WhiteContainer>
      ))}
    </div>
  );
};
